import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../constants";

export interface HomepageBlock4Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const HomepageBlock4 = forwardRef<HTMLDivElement, HomepageBlock4Props>(
  ({ header, content, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-8 md:wb-grid lg:wb-grid-cols-3 xl:wb-grid-cols-3 md:wb-items-center wb-mx-auto">
                {content}
              </BlockSection.NestedBlock>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

HomepageBlock4.displayName = "HomepageBlock4";
